// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {BlockCornerType} from './block-corner-type.js'
import {Id} from './id.js'
import {Point} from './point.js'
import {SeqId} from './seq-id.js'
import {SetColor} from './set-color.js'
import {SetFloat} from './set-float.js'
import {SetPaper} from './set-paper.js'
import {SetRect} from './set-rect.js'
import {SetSize} from './set-size.js'
import {SetString} from './set-string.js'
import {Size} from './size.js'
import {TextWrapMode} from './text-wrap-mode.js'

export class ModifyBlock {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyBlock {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyBlock(bb: flatbuffers.ByteBuffer, obj?: ModifyBlock): ModifyBlock {
    return (obj || new ModifyBlock()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyBlock(bb: flatbuffers.ByteBuffer, obj?: ModifyBlock): ModifyBlock {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyBlock()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  blocks(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  blocksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  corner(): BlockCornerType | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  page(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  origin(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  rotation(obj?: SetFloat): SetFloat | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? (obj || new SetFloat()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  scale(obj?: SetSize): SetSize | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? (obj || new SetSize()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  size(obj?: Size): Size | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? (obj || new Size()).__init(this.bb_pos + offset, this.bb!) : null
  }

  textWrap(): TextWrapMode | null {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  enableCaption(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  mathLatex(obj?: SetString): SetString | null {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? (obj || new SetString()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  mathColor(obj?: SetColor): SetColor | null {
    const offset = this.bb!.__offset(this.bb_pos, 26)
    return offset ? (obj || new SetColor()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  cropRect(obj?: SetRect): SetRect | null {
    const offset = this.bb!.__offset(this.bb_pos, 28)
    return offset ? (obj || new SetRect()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  paper(obj?: SetPaper): SetPaper | null {
    const offset = this.bb!.__offset(this.bb_pos, 30)
    return offset ? (obj || new SetPaper()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  imageFlippedHorizontally(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 32)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  imageFlippedVertically(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 34)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  resizesWidthToFitText(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 36)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  positionLocked(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 38)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startModifyBlock(builder: flatbuffers.Builder) {
    builder.startObject(18)
  }

  static addBlocks(builder: flatbuffers.Builder, blocksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, blocksOffset, 0)
  }

  static startBlocksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static addCorner(builder: flatbuffers.Builder, corner: BlockCornerType) {
    builder.addFieldInt8(1, corner, null)
  }

  static addPage(builder: flatbuffers.Builder, pageOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, pageOffset, 0)
  }

  static addOrigin(builder: flatbuffers.Builder, originOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, originOffset, 0)
  }

  static addRotation(builder: flatbuffers.Builder, rotationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, rotationOffset, 0)
  }

  static addScale(builder: flatbuffers.Builder, scaleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, scaleOffset, 0)
  }

  static addSize(builder: flatbuffers.Builder, sizeOffset: flatbuffers.Offset) {
    builder.addFieldStruct(6, sizeOffset, 0)
  }

  static addTextWrap(builder: flatbuffers.Builder, textWrap: TextWrapMode) {
    builder.addFieldInt8(7, textWrap, null)
  }

  static addEnableCaption(builder: flatbuffers.Builder, enableCaption: boolean) {
    builder.addFieldInt8(8, +enableCaption, null)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(9, zIndex, null)
  }

  static addMathLatex(builder: flatbuffers.Builder, mathLatexOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, mathLatexOffset, 0)
  }

  static addMathColor(builder: flatbuffers.Builder, mathColorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, mathColorOffset, 0)
  }

  static addCropRect(builder: flatbuffers.Builder, cropRectOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, cropRectOffset, 0)
  }

  static addPaper(builder: flatbuffers.Builder, paperOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, paperOffset, 0)
  }

  static addImageFlippedHorizontally(builder: flatbuffers.Builder, imageFlippedHorizontally: boolean) {
    builder.addFieldInt8(14, +imageFlippedHorizontally, null)
  }

  static addImageFlippedVertically(builder: flatbuffers.Builder, imageFlippedVertically: boolean) {
    builder.addFieldInt8(15, +imageFlippedVertically, null)
  }

  static addResizesWidthToFitText(builder: flatbuffers.Builder, resizesWidthToFitText: boolean) {
    builder.addFieldInt8(16, +resizesWidthToFitText, null)
  }

  static addPositionLocked(builder: flatbuffers.Builder, positionLocked: boolean) {
    builder.addFieldInt8(17, +positionLocked, null)
  }

  static endModifyBlock(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // blocks
    return offset
  }
}
